
// src/web/components/groups-page.jsx

import React from 'react'
import connect from '../../connects/groups-page'
import GroupNav from './group-nav.jsx'
import GroupAlbum from './group-album.jsx'
import {
  Panel,
} from 'react-toolbox/lib/layout'
import PdfPreviewDialog from './pdf-preview-dialog'

class GroupsPage extends React.Component {

  openAlbum = () => {
    this.props.updateUI({ openAlbum: true })
  }
  closeAlbum = () => {
    this.props.updateUI({ openAlbum: false })
  }

  openPdf = (pdf, open) => {
    this.props.updateUI({ pdf: pdf, openPdf: open })
  }
  closePdf = () => {
    this.props.updateUI({ pdf: false, openPdf: false})
  }
  openSearchDrawer = () => this.props.updateUI({ openDrawer: !this.props.ui.openDrawer })

  render() {
    const {
      t,
      ui,
      children,
      params,
      location,
      group,
      closeDialog,
    } = this.props

    return (
      <Panel style={{ height: '100vh', position: 'fixed' }}>
        {group && <GroupNav group={group} openAlbum={this.openAlbum} openSearchDrawer={this.openSearchDrawer} openDrawer={ui.openDrawer}/>}
        {ui.openPdf && <PdfPreviewDialog file={ui.pdf} open={ui.openPdf} onClose={this.closePdf} t={t} />}
        {ui.openAlbum && <GroupAlbum group={group} open={ui.openAlbum} closeAlbum={this.closeAlbum} openPdf={this.openPdf} t={t}/>}
        {children}
      </Panel>
    )
  }
}

export const RawGroupsPage = GroupsPage
export default connect(GroupsPage)



// WEBPACK FOOTER //
// ./src/web/components/groups-page.jsx